module.exports = __webpack_public_path__ + "img/delete.b7d171e4.png";